import proj4 from 'proj4';
import { Image as ImageLayer } from 'ol/layer.js';
import Static from 'ol/source/ImageStatic.js';
import { register } from 'ol/proj/proj4.js';
import { setLayerVisibility } from '@ro-utils/common/helpers';

import { LAYER_RADAR } from '@ro-utils/constant';

const addImage = (map, epsg, extent, url, RoUUID, props) => {
  const { userSettings } = props;
  const { visibility, radar, layersIndex } = userSettings;
  const imageLayer = new ImageLayer({
    className: LAYER_RADAR,
    visible: Number(visibility.radar),
    opacity: parseFloat(radar.opacity) / 100,
    zIndex: layersIndex.radar,
    source: new Static({
      crossOrigin: 'anonymous',
      projection: epsg,
      imageExtent: extent,
      url: url
    })
  });
  !radar.scanSmoothing &&
    imageLayer.on('prerender', function(evt) {
      evt.context.imageSmoothingEnabled = false;
      evt.context.msImageSmoothingEnabled = false;
    });
  imageLayer.meta = {
    UIType: LAYER_RADAR,
    RoUUID
  };
  global.RO_IMAGES[RoUUID] = imageLayer;
  map.addLayer(imageLayer);
};

const init = mode => {
  proj4.defs(mode.epsg, mode.transform);
  register(proj4);
};

export const setRoImage = (roVal, props) => {
  const { mapType, userSettings } = props;
  const { modes } = props.ol.radar;
  const legend = props.legend;
  const mode = legend && legend.mode;
  const { visibility } = userSettings;
  const scanUIID = roVal;
  const RoUUID = `${scanUIID}${mapType}`;
  const currentMode = modes[mode];
  mode === 'old' && init(currentMode);
  visibility.radar && setLayerVisibility(false, LAYER_RADAR, global.RO_MAP);
  global.RO_IMAGES[RoUUID]
    ? userSettings.visibility.radar && global.RO_IMAGES[RoUUID].setVisible(1)
    : mode &&
      addImage(
        global.RO_MAP,
        currentMode.epsg,
        currentMode.extent,
        `https://old.radar-opadow.pl/data/${legend.dir}/${mapType}/${scanUIID}.png`,
        RoUUID,
        props
      );
};
